import React, { useState, useEffect } from "react";
import Flatpickr from "react-flatpickr";
import DynamicFieldModal from "../Helpers/Modal/Forms/DynamicFieldModal";

export default function CustomFieldInput(props) {
  const [customField, setCustomField] = useState(props.customField);
  const [openModal, setOpenModal] = useState(false)
  const [editingField, setEditingField] = useState(null)
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    props.updateSponsorshipCustomField(customField);
  }, [customField]);

  const editModal = (field) => {
      setEditingField(field)
      setOpenModal(true)
      setEditing(field.dynamic_value)
  }

    const closeEditModal = (values) => {
        setOpenModal(false)
        setEditing(false)
        setCustomField({...customField, dynamic_value: values})
    }

  return (
    <div className="form-group">
      <label htmlFor={customField.name}>{customField.name}</label>

      {(customField.value_type == 'text' || customField.value_type == 'link') && (
        <input className="form-control" value={customField.value}
          onChange={e => {
            const val = e.target.value;
            setCustomField(customField => {
              return { ...customField, value: val }
            });
          }}
        />
      )}

      {customField.value_type == 'date' && (
        <Flatpickr className="form-control" 
          value={customField.value}
          onChange={(date, dateStr) => {
            setCustomField(customField => {
              return { ...customField, value: dateStr }
            });
          }}
        />
      )}

      {customField.value_type == 'long_text' && (
        <textarea value={customField.value} 
          onChange={e => {
            const val = e.target.value;
            setCustomField(customField => {
              return { ...customField, value: val }
            });
          }}
        className="form-control"></textarea>
      )}

      {customField.value_type == 'dynamic' && 
        <div className="input-group">
            <input 
                className="form-control" 
                placeholder="Read only, click edit button to edit and create new values"
                type="text"
                value={customField.value}
                disabled
            />
            <div className="input-group-append">
                <button className="btn btn-light btn-border" type="button" onClick={() => editModal(customField)}>Edit</button>
            </div>
        </div>
      }

      {openModal && <DynamicFieldModal close={(values) => closeEditModal(values)} field_values={editing} />}
    </div>
  );
}
